import Medusa from '@medusajs/medusa-js'
import { QueryClient } from '@tanstack/react-query'
import { bhEnv } from '@lib/env'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24,
      retry: 1,
    },
  },
})

const medusaClient = new Medusa({ baseUrl: bhEnv.backendUrl, maxRetries: 3 })

export { queryClient, medusaClient }
